__webpack_require__.p = "https://master.treatspa.net/";